<template>
  <Insurances v-if="$store.state.loggedIn"/>
  <Landing v-else/>
  
</template>

<script>
import Landing from '@/views/static/landing/Index'
import Insurances from '@/views/Insurances'

export default {
  components: {
    Landing,
    Insurances
  },
  data() {
    return {
      
    }
  },
}
</script>
